import {createFeatureSelector, createSelector} from '@ngrx/store';
import {MySettingsState} from '../reducers/my-settings.reducer';

export const selectMySettingsState = createFeatureSelector<MySettingsState>('mySettings');

export const selectLoading = createSelector(selectMySettingsState, state => state.loading > 0);

export const selectPending = createSelector(selectMySettingsState, state => state.pending > 0);

export const selectFormData = createSelector(selectMySettingsState, state => state.formData);
